type CookieValue = string | boolean;

export class CookieService {
    get(key: string): CookieValue {
        const cookies: { [key: string]: CookieValue } = document.cookie
            .split(';')
            .map((cookie) => cookie.split('='))
            .reduce((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});
        return cookies[key];
    }

    set(key: string, value: CookieValue): void {
        document.cookie = `${key}=${value}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;`;
    }
}
